export const GLASS = {
  surface: {
    bg: '#ffffff',
    bgHover: '#fafafa',
    bgStrong: '#ffffff',
    bgMetric: '#ffffff',
    bgFooter: '#f6f6f6',
    blur: '0px',
    blurStrong: '0px',
  },
  border: {
    light: 'rgba(82, 86, 99, 0.08)',
    subtle: 'rgba(82, 86, 99, 0.06)',
    outer: 'rgba(82, 86, 99, 0.18)',
    metric: 'rgba(82, 86, 99, 0.12)',
  },
  glow: {
    connected: '0 0 40px -10px rgba(247, 66, 17, 0.2)',
    disconnected: '0 0 30px -10px rgba(82, 86, 99, 0.15)',
    selected: '0 0 50px -8px rgba(247, 66, 17, 0.25)',
    hover: '0 8px 24px -4px rgba(10, 15, 45, 0.1)',
  },
  shadow: {
    card: '0 1px 3px rgba(10, 15, 45, 0.06), 0 1px 2px rgba(10, 15, 45, 0.04)',
    cardHover: '0 8px 24px -4px rgba(10, 15, 45, 0.1)',
    cardInset: 'none',
    avatar: '0 4px 20px -4px rgba(10, 15, 45, 0.15)',
    button: '0 1px 3px rgba(10, 15, 45, 0.08)',
    buttonHover: '0 4px 12px -2px rgba(10, 15, 45, 0.12)',
  },
  overlay: {
    glass: 'none',
    mint: 'none',
    neutral: 'none',
  },
  radius: {
    card: '14px',
    inner: '10px',
    metric: '12px',
    badge: '999px',
    button: '10px',
    buttonSm: '8px',
    avatar: '50%',
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    cardPadding: 24,
    cardPaddingMobile: 16,
  },
  motion: {
    duration: {
      fast: '0.15s',
      normal: '0.25s',
      slow: '0.4s',
      enter: '0.5s',
    },
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easingSpring: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  status: {
    connected: {
      color: '#10b981',
      colorDark: '#059669',
      bg: 'rgba(16, 185, 129, 0.1)',
      bgStrong: 'rgba(16, 185, 129, 0.15)',
      glow: 'rgba(16, 185, 129, 0.2)',
      dot: '#10b981',
    },
    disconnected: {
      color: '#94a3b8',
      colorDark: '#64748b',
      bg: 'rgba(148, 163, 184, 0.1)',
      bgStrong: 'rgba(148, 163, 184, 0.15)',
      glow: 'rgba(148, 163, 184, 0.15)',
      dot: '#94a3b8',
    },
  },
  text: {
    heading: '#0a0f2d',
    body: '#3a3d47',
    muted: '#525663',
    metric: '#0a0f2d',
    metricLabel: '#525663',
  },
  accent: {
    orange: '#f74211',
    orangeLight: '#ff6b42',
    orangeDark: '#d4380d',
    blue: '#3e54b5',
    blueDark: '#2e3f8a',
    green: '#10b981',
    greenNeon: '#34d399',
    greenDark: '#059669',
  },
  gradient: {
    action: 'var(--gradient-01)',
    depth: 'var(--gradient-02)',
    texture: 'var(--texture-grain)',
  },
  metric: {
    scheduled: {
      iconBg: 'rgba(62, 84, 181, 0.1)',
      iconColor: '#3e54b5',
      iconBorder: 'rgba(62, 84, 181, 0.2)',
    },
    published: {
      iconBg: 'rgba(16, 185, 129, 0.1)',
      iconColor: '#10b981',
      iconBorder: 'rgba(16, 185, 129, 0.2)',
    },
  },
  sidebar: {
    bg: '#0a0f2d',
    bgActive: 'rgba(247, 66, 17, 0.15)',
    bgActiveHover: 'rgba(247, 66, 17, 0.22)',
    bgHover: 'rgba(255, 255, 255, 0.08)',
    activeIndicator: '#f74211',
    borderRight: 'rgba(255, 255, 255, 0.08)',
  },
  shell: {
    headerBg: '#0a0f2d',
    headerBlur: '0px',
    searchBg: 'rgba(255, 255, 255, 0.1)',
    filterBg: 'rgba(255, 255, 255, 0.06)',
    filterActiveBg: '#f74211',
    filterActiveColor: '#ffffff',
  },
  header: {
    statsBg: '#ffffff',
    statsBorder: 'rgba(82, 86, 99, 0.12)',
    actionBg: '#ffffff',
  },
} as const;

export type GlassStatus = 'connected' | 'disconnected';
